export default __webpack_public_path__ + "static/media/m-logo.b76c09fd.svg";